export default class CreateBookingDateRequest {
    date: Date;
    //bookingRoleIds: string[];
}